import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { SupabaseProvider } from "./auth/SupabaseProvider";
import { queryClient } from "./lib/queryClient";

import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <SupabaseProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </SupabaseProvider>
    </BrowserRouter>
  </StrictMode>,
);
